import React, { Component, Fragment } from 'react';
import { Portal, Transition, EventListener } from 'components';
import * as css from 'styles/layout/overlay.scss';

export const Overlay = (props =>
  <Portal>
    <Transition in={props.overlay} mountOnEnter unmountOnExit classNames={css} timeout={500}>
      <div>
        <EventListener target={window} onKeyDown={event => onKeyDown(event, props)} />
        <div className={css.shade} onClick={props.close} />
        <div className={[css.modal, props.className].join(' ')} onClick={event => onClickInside(event, props)}>
          { props.children }
        </div>
      </div>
    </Transition>
  </Portal>
);

function onKeyDown({ key }, { close }) {
  if (key == 'Escape') {
    close();
  }
}

function onClickInside(event, { close }) {
  if (event.target.getAttribute('href') == '#close') {
    event.preventDefault();
    close();
  }
}
